import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

// namespace SlotGames {

    export class BambooSecrets_Responsive extends SlotGameType1_Responsive {

        
        protected override helpFactory: IHelpFactory = new BambooSecretsHelpFactory();
        constructor(multigameParams: MultigameParams , initData: SlotGameInitData , gameName : string = "BambooSecrets") {
            super(multigameParams , initData , gameName );

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }
        //LED COLOR
		protected override ColorLed:string="57,255,20\n";
     

        protected override color: RewardColor =
            {
                color: "#96DB2A",
                coloroutherStroke: "black",
                colorinnerStroke: "#DB3814",
            }
    }

    //Help Colorized
    class BambooSecretsHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new BambooSecretsHelp(params);
        }
    }

    class BambooSecretsHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
// }